/**
 * Validates a string to ensure it contains only digits (0-9).
 *
 * @param {string} value - The string to validate.
 * @returns {boolean} Returns true if the string contains only digits, otherwise false.
 */
const validateDigits = (value: string): boolean => {
  const regexpDigits = /^\d*$/;

  return regexpDigits.test(value);
};

export default validateDigits;
